/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DelegatorsRequest
 */
export interface DelegatorsRequest {
    /**
     * 
     * @type {string}
     * @memberof DelegatorsRequest
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsRequest
     */
    size: number;
}

export function DelegatorsRequestFromJSON(json: any): DelegatorsRequest {
    return DelegatorsRequestFromJSONTyped(json, false);
}

export function DelegatorsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegatorsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function DelegatorsRequestToJSON(value?: DelegatorsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'page': value.page,
        'size': value.size,
    };
}


